import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';

export const AddPlan = ( data ) => {
  const requestOptions = {
    method: 'POST',
    url: urls.subscriptions,
    data: data,
  };

  return axios(requestOptions)
    .then(res => res.data);
};

// eslint-disable-next-line import/prefer-default-export
export const GetAllCardsInfo = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.cards,
  };

  return axios(requestOptions)
    .then(res => res.data);
};

export const AddCard = (token) => {
  const requestOptions = {
    method: 'POST',
    url: urls.cards,
    data: token,
  };

  return axios(requestOptions)
    .then(res => res.data);
};

export const UpdateCard = (id, params) => {
  
  const requestOptions = {
    method: 'PUT',
    url: `${urls.card_update}/${id}`,
    data: params,
  };

  return axios(requestOptions)
    .then(res => res.data);
};

export const DeleteCard = (id) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.card_update}/${id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
};

export const GetBankInfo = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.bank_account
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetLinkToken = () => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.bank_account}/link_token`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateBankAccount = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.bank_account,
    data: {
      bank_account: data
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const AddBankAccount = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: urls.bank_account,
    data: {
      bank_account: data
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const SetBankAccountDefault = () => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.bank_account}/set_default`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteBankAccount = () => {
  const requestOptions = {
    method: 'DELETE',
    url: urls.bank_account
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const ApplyDiscountCoupon = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.coupon,
    params: {
      coupon: data
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ConnectToSpreedly = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.cards,
    params: data
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCurrentPMB = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.pmb
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAvailablePMBs = () => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.pmb}/available`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const AddCustomerPMB = (pmb) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.pmb}`,
    params: {
      private_mailbox: pmb
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveCustomerPMB = () => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.pmb}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAllCoupons = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.coupons
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateCoupon = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.coupons,
    params: {
      coupon: data
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}
export const DeleteCoupon = (id) => {
  const requestOptions = {
    method: 'Delete',
    url: `${urls.admin.coupons}/${id}`,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateCoupon = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.coupons}/${data.id}`,
    params: {
      coupon: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCouponUsers = (id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.coupons}/${id}/user_coupons`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveCouponFromUser = (params) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.coupons}/${params.couponId}/user_coupons/${params.customerId}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAdminGateway = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.payment_gateway
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateAdminGateway = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: urls.admin.payment_gateway,
    data
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAdminCard = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.credit_card
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateAdminCard = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.credit_card,
    data
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAppProvider = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.app_provider
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const RunTestBilling = (data) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.customers}/${data.id}/run_billing`,
    data: {
      billing_date: data.billing_date
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetClientBankAccount = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.client_bank_account
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateClientBankAccount = (params) => {
  const requestOptions = {
    method: 'PUT',
    url: urls.admin.client_bank_account,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteClientBankAccount = () => {
  const requestOptions = {
    method: 'DELETE',
    url: urls.admin.client_bank_account
  }

  return axios(requestOptions)
    .then(res => res.data);
}